import { callCareersApi } from "./careers-api";

export type EntradaPostulacion = {
  posicion_id: string;
  segunda_opcion_id: string | null;
  turno_preferencia: string;
  disponibilidad_otro_turno: string;
  fecha_incorporacion: string | null;
  postulante: {
    nombre_completo: string;
    fecha_nacimiento: string | null;
    telefono: string;
    correo: string;
    municipio: string;
    area_experiencia: string;
    ultimo_puesto: string;
    anios_experiencia: number;
    escolaridad: string;
    carrera: string;
    institucion: string;
    cedula_profesional: string | null;
    certificaciones: string | null;
    disponibilidad_horario: string;
    disponibilidad_capacitacion: string;
  };
  respuestas: { pregunta: string; respuesta: string }[];
  documentos: { tipo: string; nombre_archivo: string; ruta: string }[];
};

export const crearPostulacion = async (data: EntradaPostulacion) =>
  callCareersApi<{ folio: string }>("/postulaciones", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const resumenAdmin = async () => callCareersApi<any>("/admin/resumen");

export const listarPostulacionesAdmin = async () => callCareersApi<any[]>("/admin/postulaciones");

export const obtenerPostulacionAdmin = async (data: { id: string }) =>
  callCareersApi<any>(`/admin/postulaciones/${data.id}`);

export const actualizarPostulacionAdmin = async (data: {
  id: string;
  estatus?:
    | "nueva"
    | "en_revision"
    | "entrevista"
    | "evaluacion"
    | "seleccionado"
    | "reserva"
    | "no_seleccionado"
    | "retirada";
  estatusAnterior?: string | null;
  calificacion?: number | null;
  fortalezas?: string[];
  aspectos_validar?: string[];
  comentario?: string | null;
}) =>
  callCareersApi<{ ok: true }>(`/admin/postulaciones/${data.id}/estado`, {
    method: "POST",
    body: JSON.stringify(data),
  });

export const agregarNotaAdmin = async (data: { postulacion_id: string; nota: string }) =>
  callCareersApi<{ ok: true }>(`/admin/postulaciones/${data.postulacion_id}/notas`, {
    method: "POST",
    body: JSON.stringify(data),
  });

export const urlDocumentoAdmin = async (data: { ruta: string }) =>
  callCareersApi<{ url: string }>("/admin/documentos/url", {
    method: "POST",
    body: JSON.stringify(data),
  });
